import axios from 'axios'
import { capiCreator } from 'tr-components/redux/CallApiMiddlewareActionCreator'

export const SORT = 'fields/SORT'
export const SEARCH = 'fields/SEARCH'
export const UPDATE_PAGE = 'fields/UPDATE_PAGE'

export const FETCH_FIELDS = 'fields/FETCH_FIELDS'
export const FETCH_FIELDS_SUCCESS = 'fields/FETCH_FIELDS_SUCCESS'
export const FETCH_FIELDS_FAIL = 'fields/FETCH_FIELDS_FAIL'

export const FETCH_FIELD = 'fields/FETCH_FIELD'
export const FETCH_FIELD_SUCCESS = 'fields/FETCH_FIELD_SUCCESS'
export const FETCH_FIELD_FAIL = 'fields/FETCH_FIELD_FAIL'

export const SAVE_FIELD = 'fields/SAVE_FIELD'
export const SAVE_FIELD_SUCCESS = 'fiels/SAVE_FIELD_SUCCESS'
export const SAVE_FIELD_FAIL = 'fields/SAVE_FIELD_FAIL'

export const UPDATE_STATUS = 'fields/UPDATE_STATUS'
export const UPDATE_STATUS_SUCCESS = 'fields/UPDATE_STATUS_SUCCESS'
export const UPDATE_STATUS_FAIL = 'fields/UPDATE_STATUS_FAIL'

export const DELETE_FIELD = 'fields/DELETE_FIELD'
export const DELETE_FIELD_SUCCESS = 'fields/DELETE_FIELD_SUCCESS'
export const DELETE_FIELD_FAIL = 'fields/DELETE_FIELD_FAIL'

export const REORDER_FIELD = 'fields/REORDER_FIELD'
export const UPDATE_FIELDS_ORDER = 'fields/UPDATE_FIELDS_ORDER'
export const UPDATE_FIELDS_ORDER_SUCCESS = 'fields/UPDATE_FIELDS_ORDER_SUCCESS'
export const UPDATE_FIELDS_ORDER_FAIL = 'fields/UPDATE_FIELDS_ORDER_FAIL'

export const initialState = {
  deleteErr: null,
  deleting: false,
  saving: false,
  saveError: null,
  updatingStatus: false,
  updateStatusError: null,
  updatingOrder: false,
  updatingOrderError: null,
  fetching: false,
  fetchingById: false,
  err: null,
  fetchByIdErr: null,
  fields: [],
  activeField: null,
  total: 0,
  sortStatus: {
    ascending: true,
    key: 'name',
    index: 2
  },
  pagination: {
    pageNumber: 1,
    pageSize: 30
  },
  rowsPerPageOptions: [10, 30, 50],
  visiblePageButtonsCount: 5,
  searchText: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SORT:
      return {
        ...state,
        sortStatus: action.sortStatus
      }
    case UPDATE_PAGE:
      return {
        ...state,
        pagination: action.pagination
      }
    case SEARCH:
      return {
        ...state,
        searchText: action.term
      }
    case FETCH_FIELDS:
      return {
        ...state,
        fetching: true,
        err: null,
        activeField: null
      }
    case FETCH_FIELDS_FAIL:
      return {
        ...state,
        fetching: false,
        err: action.payload
      }
    case FETCH_FIELDS_SUCCESS:
      return {
        ...state,
        err: null,
        fetching: false,
        fields: action.payload.fields.map(populateDate),
        total: action.payload.total
      }
    case FETCH_FIELD:
      return {
        ...state,

        fetchingById: true,
        fetchByIdErr: null,
        activeField: null
      }
    case FETCH_FIELD_FAIL:
      return {
        ...state,
        fetchingById: false,
        fetchByIdErr: action.payload
      }
    case FETCH_FIELD_SUCCESS:
      return {
        ...state,
        fetchingById: false,
        activeField: {
          ...action.payload,
          legacy: action.payload.legacyId < 2500
        }
      }
    case SAVE_FIELD:
      return {
        ...state,
        saving: true,
        saveError: null,
        activeField: action.payload
      }
    case SAVE_FIELD_SUCCESS:
      return {
        ...state,
        saving: false,
        saveError: null,
        activeField: null
      }
    case SAVE_FIELD_FAIL:
      return {
        ...state,
        saving: false,
        saveError: action.payload
      }
    case UPDATE_STATUS:
      return {
        ...state,
        updatingStatus: true,
        updateStatusError: null
      }
    case UPDATE_STATUS_SUCCESS:
      return {
        ...state,
        updatingStatus: false,
        fields: state.fields.map((field) =>
          field.id === action.payload.id ? action.payload : field
        )
      }
    case UPDATE_STATUS_FAIL:
      return {
        ...state,
        updatingStatus: false,
        updateStatusError: action.payload
      }
    case DELETE_FIELD:
      return {
        ...state,
        deleting: true,
        deleteErr: null
      }
    case DELETE_FIELD_SUCCESS:
      return {
        ...state,
        deleting: false
      }
    case DELETE_FIELD_FAIL:
      return {
        ...state,
        deleting: false,
        deleteErr: action.payload
      }
    case REORDER_FIELD:
      return {
        ...state,
        fields: action.reorderArr
      }

    case UPDATE_FIELDS_ORDER:
      return {
        ...state,
        updatingOrder: true,
        updatingOrderError: null
      }
    case UPDATE_FIELDS_ORDER_SUCCESS:
      return {
        ...state,
        updatingOrder: false
      }
    case UPDATE_FIELDS_ORDER_FAIL:
      return {
        ...state,
        updatingOrder: false,
        updatingOrderError: action.payload
      }
    default:
      return state
  }
}

export default reducer

export const fetchFieldById = (id) =>
  capiCreator(FETCH_FIELD, FETCH_FIELD_SUCCESS, FETCH_FIELD_FAIL, () => axios.get(`/fields/${id}`))

export const updateStatus = (field) =>
  capiCreator(
    UPDATE_STATUS,
    UPDATE_STATUS_SUCCESS,
    UPDATE_STATUS_FAIL,
    () => axios.put(`/fields/${field.id}`, field),
    field
  )

export const saveField = (field) => {
  const create = () => () => axios.post('/fields', field)
  const update = (id) => () => axios.put(`/fields/${id}`, field)

  return capiCreator(
    SAVE_FIELD,
    SAVE_FIELD_SUCCESS,
    SAVE_FIELD_FAIL,
    field.id ? update(field.id) : create(),
    field
  )
}

export const sortFields = (sortStatus) => updateList({ type: SORT, sortStatus })

export const updatePage = (pagination) => {
  return updateList({ type: UPDATE_PAGE, pagination })
}

export const getAllFields = () => {
  const params = {
    asc: true,
    orderBy: 'order'
  }

  return capiCreator(
    FETCH_FIELDS,
    FETCH_FIELDS_SUCCESS,
    FETCH_FIELDS_FAIL,
    () => axios.get('/fields', { params }),
    { params }
  )
}

export const reorderField = (reorderArr) => {
  return {
    type: REORDER_FIELD,
    reorderArr
  }
}

export const updateFieldOrdering = (updatedOrderArr) =>
  capiCreator(
    UPDATE_FIELDS_ORDER,
    UPDATE_FIELDS_ORDER_SUCCESS,
    UPDATE_FIELDS_ORDER_FAIL,
    () => axios.put('/updateOrder', updatedOrderArr),
    { updatedOrderArr }
  )

export const search = (term) => updateList({ type: SEARCH, term })

export const deleteField = (id) =>
  capiCreator(
    DELETE_FIELD,
    DELETE_FIELD_SUCCESS,
    DELETE_FIELD_FAIL,
    () => axios.delete(`/fields/${id}`),
    id
  )

// 'private' helpers

const updateList = (beforeAction) => (dispatch, getState) => {
  if (beforeAction) dispatch(beforeAction)
  const action = get(getState)
  dispatch(action).then(({ type, payload }) => {
    /*
     * If we are searching, and get a result with no fields, but a total greater than 0,
     * then set pagination page to 1 and do search again.
     *
     * This happens when you are on page 3 search for a term, and there are results, but not 3 pages
     * of results.
     *
     * This can also happen if you delete the only item visible on a page but there are still items to view on
     * previous pages.
     */
    if (type === FETCH_FIELDS_SUCCESS) {
      const { total, fields } = payload
      if (fields.length === 0 && total > 0) {
        dispatch(
          updatePage({
            ...getState().fields.pagination,
            pageNumber: 1
          })
        )
      }
    }
  })
}

const sortMap = {
  'last Modified': 'dateModified',
  status: 'isActive'
}

const get = (getState) => {
  const { sortStatus, pagination, searchText } = getState().fields
  const params = {
    asc: sortStatus.ascending,
    orderBy: sortMap[sortStatus.key] || sortStatus.key,
    ...pagination,
    searchText
  }

  return capiCreator(
    FETCH_FIELDS,
    FETCH_FIELDS_SUCCESS,
    FETCH_FIELDS_FAIL,
    () => axios.get('/fields', { params }),
    params
  )
}

export const populateDate = (module) => {
  return {
    ...module,
    lastModified: new Date(module.lastModified)
  }
}



// WEBPACK FOOTER //
// ./src/modules/CustomFields/redux/customFields.js